export default __webpack_public_path__ + "static/media/child4.ef5fdb83.png";